import React, { useEffect, useState } from 'react'
import { CgArrowLeft } from 'react-icons/cg'
import { GoLocation } from 'react-icons/go'
import { Link, useParams } from 'react-router-dom'
import About from './partials/About'
import Enrollement from './partials/Enrollment'
import { GrEdit } from 'react-icons/gr'
import axios from 'axios'
import { urlRecruiter } from '../../../../../../api'
import { JOB_API_END_POINT } from '../../../../../utils/constant'
import { useSelector } from 'react-redux'

const Enrollments = () => {
  const { id, opt } = useParams()
  const [option, setOption] = useState(opt?.toString() || "1")
  const [postData, setPostData] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const {user} = useSelector(store=>store.user);

  useEffect(() => {
    const fetchPostData = async () => {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("user_id", 2);
        formDataToSend.append("offer_id", 1);
        const response = await axios.get(`${JOB_API_END_POINT}/recruiter/${1}?user_id=2&offer_id=1}`)
        setPostData(response.data)
        setLoading(false)
        // console.log("recruitment data", response.data)
      } catch (err) {
        setError("Erreur lors du chargement des données", err)
        setLoading(false)
      }
    }
    fetchPostData()
  }, [id])
  

  if (loading) return <div className="fixed w-screen flex h-screen items-center justify-center bg-white/20 backdrop-blur-sm backdrop-filter">
  <div className="size-10 animate-spin rounded-full border-4 border-solid border-gray-700 border-t-transparent"></div>
</div>
  if (error) return <p>{error}</p>

  return (
    <div className='layout-1'>
      <Link to={`/${urlRecruiter}/offre`} className="flex gap-2 items-center mb-4 text-primary-text text-sm">
        <CgArrowLeft/>
        <h1 className=''>Retour à la liste</h1>
      </Link>

      <h2 className='text-start mb-1 font-semibold text-xl flex items-start gap-x-2'>
        {postData?.job_title} 
        <div className='flex items-center gap-1 rounded-full border text-sm py-1 px-2 font-normal border-[#3700c3] bg-[#3700c3]/5 text-[#3700c3]'>
          <span className='w-2.5 h-2.5 rounded-full bg-[#3700c3]'></span> {postData?.status || "Disponible"}
        </div>
        <Link to={`/${urlRecruiter}/offre/${id}/modifier`} className='hover:bg-neutral-100 rounded-full p-1.5'>
          <GrEdit/>
        </Link>
      </h2>

      <div className="flex gap-1 items-center">
        <GoLocation/> {user?.organisation_profile?.address || postData?.address}
      </div>
      
      <div className="border rounded-md grid grid-cols-2 md:grid-cols-4 gap-4 text-start mt-4 py-4 px-6">
        <div>
          <p className='text-sm text-primary-text'>Type de contrat</p>
          <p className='font-semibold text-sm'>{postData?.contract_type}</p>
        </div>
        <div>
          <p className='text-sm text-primary-text'>Reférence</p>
          <p className='font-semibold text-sm'>{postData?.reference || "Aucun"}</p>
        </div>
        <div>
          <p className='text-sm text-primary-text'>Expérience requise</p>
          <p className='font-semibold text-sm'>{postData?.experience}</p>
        </div>
        <div>
          <p className='text-sm text-primary-text'>Salaire</p>
          <p className='font-semibold text-sm'>{postData?.salary}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 text-sm">
        <div className="col-span-4 ">
          <div className="flex sticky top-0 border-b w-full my-4 text-sm bg-white pt-2">
            <button onClick={() => setOption("1")} className={`px-6 py-2 border-b-2 hover:text-primary-black ${option === "2" ? "border-b-transparent text-primary-text font-normal" : "border-b-gray-950 text-primary-black font-bold"}`}>
              Description
            </button>
            <button onClick={() => setOption("2")} className={`px-6 py-2 border-b-2 hover:text-primary-black ${option === "1" ? "border-b-transparent text-primary-text font-normal" : "border-b-gray-950 text-primary-black font-bold"}`}>
              Candidats  ({postData?.applications?.length || 0})
            </button>
          </div>
        </div>
      </div>

      {option === "1" && <About item={postData} />}
      {option === "2" && <Enrollement data={postData} />}
    </div>
  )
}

export default Enrollments
